import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./about.scss";
// Components
import TeamBox from './teamBox';
import TeamInfo from "./teamInfo";
import Title from "../ui-components/title/title";
// Assets
import Person01 from "../../assets/about/person01.png";
import Person02 from "../../assets/about/792b18b0-f86d-480f-9a28-9f8ba68ed758.png";

const about = () => (
  <div id="about">
    <div className="wrapper">
      <Title title="ABOUT US." />
      <p className="font12" style={{maxWidth:"500px", textAlign:"justify"}}>
      Nossa equipe é composta por profissionais talentosos e dedicados, 
      prontos para enfrentar qualquer desafio e criar soluções impactantes para nossos clientes. Conheça quem faz parte dessa história!
      </p>
      <Row>
        <Col md={12} lg={4}>
          <TeamBox avatar={Person01} name="Arthur Adan" job="Diretor de Arte" />
        </Col>
        <Col md={12} lg={4}>
          <TeamInfo />
        </Col>
      </Row>
    </div>
  </div>
);

export default about;
